import {epos2Axios} from "@/interceptors/axios";

class CustomerService {
    async getAllCustomers(serverOptions) {

        console.log(serverOptions);

        let config = {
            params: {
                page: serverOptions.page,
                limit: serverOptions.rowsPerPage,
                order_by: serverOptions.sortBy,
                order_direction: serverOptions.sortType,
                filters: serverOptions.filters,
                search: serverOptions.searchStr,
            },
        }

        const response = await epos2Axios.get('/api/customers', config);

        return {
            serverCurrentPageItems: response.data.data.customers,
            serverTotalItemsLength: response.data.data.pagination.found_rows,
        };
    }

    async searchCustomers(serverOptions) {
        console.log(serverOptions)
        try {
            let config = {
                params: {
                    page: serverOptions.page,
                    limit: serverOptions.rowsPerPage,
                    order_by: serverOptions.sortBy,
                    order_direction: serverOptions.sortType,
                    filters: serverOptions.filters,
                },
            }

            config.params.customer_type = serverOptions.customerType;
            config.params.sales_id = serverOptions.salesID;
            config.params.filter_option = serverOptions.filter_option;
            config.params.start_date = serverOptions.start_date;
            config.params.end_date = serverOptions.end_date;

            const response = await epos2Axios.get('/api/customers/analytics', config);

            return {
                serverCurrentPageItems: response.data.data.customers,
                serverTotalItemsLength: response.data.data.pagination.found_rows,
            };
        } catch (error) {
            console.error('Error fetching data:', error);
            return {
                serverCurrentPageItems: [],
                serverTotalItemsLength: 0,
            };
        }
    }


    async downloadCustomers(serverOptions) {
        try {
            let  params = {
                order_by: serverOptions.sortBy,
                order_direction: serverOptions.sortType,
                filters: serverOptions.filters,
                export: 'csv',
            }
            if(serverOptions.customerType !== ""){
                params.customer_type = serverOptions.customerType;
            }
            if(serverOptions.salesID !== ""){
                params.sales_id = serverOptions.salesID;
            }
            if(serverOptions.filter_option !== ""){
                params.filter_option = serverOptions.filter_option;
            }
            if(serverOptions.start_date !== ""){
                params.start_date = serverOptions.start_date;
            }
            if(serverOptions.end_date !== ""){
                params.end_date = serverOptions.end_date;
            }
            const response = await epos2Axios.get('/api/customers/analytics', {
                params,
                responseType: 'blob', // Set the response type to 'blob' for binary data
            });

            const blob = new Blob([response.data], { type: 'application/zip' });

            // We create a temporary link that contains the zip file
            // we then click it programmatically to download the file
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'customers.zip';
            document.body.appendChild(link);
            link.click();

            // Remove the link from the document
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    }


    async getCustomerTypes() {
        try {
            const response = await epos2Axios.get('/api/customers/types');

            return {
                typeGroups: response.data.data.customer_type_groups,
                types: response.data.data.customer_types,
            };
        } catch (error) {
            console.error('Error fetching customer types:', error);
            return {
                typeGroups: [],
                types: [],
            };
        }
    }

    async getSalesContacts() {
        try {
            const response = await epos2Axios.get('/api/customers/salescontacts');

            return {
                sales_contacts: response.data.data.sales_contacts,
            };
        } catch (error) {
            console.error('Error fetching customer types:', error);
            return {
                typeGroups: [],
                types: [],
            };
        }
    }
}

export default new CustomerService();